<template>
  <ul class="attachment">
    <li class="attachment__item" @click.stop v-if="allowInputs.files">
      <label class="attachment__label">
        <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.70187 17.3858C4.34186 16.5361 3.24 13.9671 4.20612 11.6498L7.65684 3.37265C8.38585 1.62389 10.4293 0.717881 12.2149 1.35207C13.983 1.98005 14.8285 3.88317 14.1056 5.61712L11.0954 12.8276C10.6043 14.0056 9.21554 14.6078 8.0205 14.1593C6.86919 13.7272 6.34145 12.4673 6.81556 11.33L9.18256 5.66313C9.28436 5.41944 9.57048 5.2892 9.82162 5.37225L10.7309 5.67294C10.9821 5.756 11.1031 6.0209 11.0013 6.26458L8.63462 11.9309C8.55348 12.1256 8.64253 12.3497 8.82936 12.4198C9.00738 12.4867 9.20325 12.4022 9.27633 12.2269L12.2865 5.01646C12.6091 4.24253 12.2286 3.38405 11.438 3.10327C10.6649 2.82874 9.79197 3.21541 9.47617 3.97294L6.02541 12.2501C5.45355 13.6219 6.10899 15.1414 7.48662 15.6375C8.86031 16.1321 10.4204 15.4419 10.9809 14.0974L13.8115 7.30789C13.9131 7.06413 14.1991 6.93374 14.4503 7.01662L15.3599 7.31671C15.6111 7.39959 15.7324 7.66439 15.6308 7.90816L12.8003 14.6977C11.8202 17.0485 9.07795 18.2414 6.70187 17.3858Z" fill="currentColor"/>
        </svg>
        <input class="attachment__file-input" type="file" multiple @change="attachFiles">
      </label>
    </li>
    <li class="attachment__item"
        :class="linkTooltip.active ? 'active' : ''" v-if="allowInputs.links"
        @click.stop="toggleLinkTooltip"
        ref="linkTooltip"
        @focusout="handleBlur($event, closeLinkTooltip, 'linkTooltip')"
        tabindex="-1"
    >
      <transition name="fade">
        <div class="tooltip" @click.stop v-if="linkTooltip.active">
          <div v-if="linkTooltip.text">
            <div class="tooltip__input">
              <AppInput title="Текст"
                        class="tooltip__input_not-editable"
                        :value="linkTooltip.text"
                        :valid="linkTooltip.textValid"
              />
            </div>
            <div class="tooltip__input">
              <AppInput title="Адрес"
                        :value="linkTooltip.url"
                        :valid="linkTooltip.urlValid"
                        @value-changed="setLinkUrl"
                        @got-focus="clearValidation"
                        @keyup-enter="attachLink"
              />
            </div>
            <div class="tooltip__button-wrap">
              <div class="tooltip__button">
                <AppButton type="main"
                           title="Добавить"
                           @click.stop.native="attachLink"
                />
              </div>
              <div class="tooltip__button">
                <AppButton type="alt"
                           title="Отмена"
                           @click.stop.native="closeLinkTooltip"
                />
              </div>
            </div>
          </div>
          <div class="tooltip__message" v-else>
            Выделите текст для ссылки
          </div>
        </div>
      </transition>
      <svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="6.33801" y="0.967485" width="5.84402" height="7.23362" rx="1.25" transform="rotate(15.5426 6.33801 0.967485)" stroke="currentColor" stroke-width="1.5"/>
        <rect x="3.81848" y="10.0231" width="5.84402" height="7.23362" rx="1.25" transform="rotate(15.5426 3.81848 10.0231)" stroke="currentColor" stroke-width="1.5"/>
        <rect x="7.41655" y="6.16204" width="0.950762" height="6.5352" rx="0.475381" transform="rotate(15.5426 7.41655 6.16204)" stroke="currentColor" stroke-width="0.950762"/>
      </svg>
    </li>
    <li class="attachment__item"
        :class="tagTooltip.active ? 'active' : ''" v-if="allowInputs.tags"
        @click.stop="toggleTagTooltip"
        ref="tagTooltip"
        @focusout="handleBlur($event, closeTagTooltip, 'tagTooltip')"
        tabindex="-1"
    >
      <transition name="fade">
        <div class="tooltip" @click.stop v-if="tagTooltip.active">
          <div class="tooltip__input">
            <AppInput title="Тэг"
                      :value="tagTooltip.text"
                      :valid="tagTooltip.valid"
                      @value-changed="setTagText"
                      @got-focus="clearValidation"
                      @keyup-enter="attachTag"
            />
          </div>
          <div class="tooltip__button-wrap">
            <div class="tooltip__button">
              <AppButton type="main"
                         title="Добавить"
                         @click.stop.native="attachTag"
              />
            </div>
            <div class="tooltip__button">
              <AppButton type="alt"
                         title="Отмена"
                         @click.stop.native="closeTagTooltip"
              />
            </div>
          </div>
        </div>
      </transition>
      <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.297 5.6558L9.8648 5.63781L8.74549 9.6185L9.93566 9.63345L9.62892 11.5664L8.19668 11.5485L7.35228 14.5238L4.99212 14.4942L5.83652 11.5188L3.59739 11.4907L2.75299 14.466L0.392831 14.4364L1.23723 11.461L0.0874071 11.4466L0.373975 9.51333L1.78604 9.53107L2.90535 5.55038L1.73535 5.53568L2.02192 3.60243L3.45416 3.62043L4.235 0.886367L6.59516 0.916016L5.81432 3.65008L8.05344 3.6782L8.83428 0.944146L11.1944 0.973795L10.4136 3.70785L11.5836 3.72255L11.297 5.6558ZM6.38533 9.58885L7.50464 5.60816L5.26551 5.58003L4.1462 9.56072L6.38533 9.58885Z" fill="white"/>
      </svg>
    </li>
  </ul>
</template>

<script>
import AppInput from '@/components/page/input/AppInput'
import AppButton from '@/components/page/button/AppButton'
export default {
  name: 'app-message-attachment',
  components: { AppButton, AppInput },
  props: {
    allowInputs: {
      type: Object,
      default: () => {
        return {
          files: true,
          links: true,
          tags: true
        }
      }
    },
    linkTooltip: Object,
    tagTooltip: Object,
    disabled: Boolean
  },
  data () {
    return {}
  },
  methods: {
    attachFiles (event) {
      const files = event.currentTarget.files
      this.$emit('attach-files', files)
      // нужно очищать инпут после того как файлы улетели в стор, иначе если удалить и заного добавить один и тот же файл
      // то ничего не произойдёт, @change не сработает, так как значение не изменилось
      event.currentTarget.value = ''
    },
    toggleLinkTooltip () {
      this.$emit('toggle-link-tooltip')
    },
    closeLinkTooltip () {
      this.$emit('close-link-tooltip')
    },
    setLinkText (text) {
      this.$emit('set-link-text', text)
    },
    setLinkUrl (url) {
      this.$emit('set-link-url', url)
    },
    attachLink () {
      this.$emit('attach-link')
    },
    toggleTagTooltip () {
      this.$emit('toggle-tag-tooltip')
    },
    closeTagTooltip () {
      this.$emit('close-tag-tooltip')
    },
    setTagText (text) {
      this.$emit('set-tag-text', text)
    },
    attachTag () {
      this.$emit('attach-tag')
    },
    clearValidation () {
      this.$emit('clear-validation')
    },
    handleBlur (event, callBack, block) {
      const enteringParent = !this.$refs[block].contains(event.relatedTarget)

      if (enteringParent) {
        callBack()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.attachment {
  position: relative;
  z-index: 10;
  display: flex;
  flex-flow: row nowrap;
  margin: 0 !important;

  &__item {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    @include size(29px);
    border-radius: 50%;
    background: $color_deactive;
    color: $color_main;
    margin-right: 15px;
    cursor: pointer;
    transition: .3s;

    &:last-child {
      margin-right: 0;
    }

    &.active {
      background: $color_second-light;
    }

    @media screen and (min-width: $hover-enable_width) {
      &:hover {
        background: $color_second-light;
      }
    }
  }

  &__label {
    cursor: pointer;
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
  }

  &__file-input {
    display: none;
  }
}

.tooltip  {
  position: absolute;
  top: auto;
  left: -10px;
  bottom: calc(100% + 10px);
  background: $color_main;
  padding: 20px 40px 20px 20px;
  border: 1px solid $border_color;
  border-radius: 3px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  cursor: auto;

  &__input {
    margin-bottom: 20px;

    &_not-editable {
      pointer-events: none;
    }
  }

  &__button-wrap {
    margin-top: 40px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
  }

  &__button {
    margin-right: 32px;

    &:last-child {
      margin-right: 0;
    }
  }

  &__message {
    white-space: nowrap;
    color: $font_color_main;
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: auto;
    left: 20px;
    bottom: -6px;
    margin: 0 auto;
    width: 10px;
    height: 10px;
    background: linear-gradient(-45deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, #ffffff 50%, #ffffff 100%);
    border: 1px solid #C4C4C4;
    border-bottom: none;
    border-right: none;
    transform: rotate(-135deg);
    box-shadow: 2px 2px 0 1px #ffffff, -2px 0px 3px rgba(0, 0, 0, 0.25);
  }
}
</style>
